export const ADMIN_GET_BRAND = 'ADMIN_GET_BRAND'
export const ADMIN_ADD_BRAND = 'ADMIN_ADD_BRAND'
export const ADMIN_UPDATE_BRAND = 'ADMIN_UPDATE_BRAND'
export const ADMIN_DELETE_BRAND = 'ADMIN_DELETE_BRAND'
